(() => {
  if (!App.settings.optimizeQuickReorderAndLogin) return;

  TrackApp.userLogin = (() => {
    const trackLoginFormExposed = async () => {
      // Fetch quick reorder items if not fetched before. It needs to make "flowType".
      await App.common.quickreorder.hasLensQuickReorderAsync();
      const flowType = TrackApp.reorder.getReorderFlowType();
      TrackApp.trackInteraction(
        'pop-up login form',
        'pop-up login form exposed',
        `pop-up login form exposed ${flowType}`,
      );
    };

    const trackUserLogin = async function (message = 'login success - login form') {
      const $defer = $.Deferred();
      TrackApp.trackInteraction('user', 'login', message);
      setTimeout(() => {
        $defer.resolve();
      }, 300);
      return $defer;
    };

    return {
      trackLoginFormExposed,
      trackUserLogin,
    };
  })();
})();
